import React from 'react';
import PropTypes from 'prop-types';
import Table from '../Table/Table.jsx';
import TableCell from '../Table/TableCell.jsx';
import TableHead from '../Table/TableHead.jsx';
import TableHeader from '../Table/TableHeader.jsx';
import TableRow from '../Table/TableRow.jsx';
import ReservationStatusLabel from './ReservationStatusLabel.jsx';
import UpsellStatusLabel from './UpsellStatusLabel.jsx';
import PreArrivalInteractionLabel from './PreArrivalInteractionLabel.jsx';
import {colors} from '../../utils/colors.js';
import {formatCurrency} from '../../utils/formatCurrency.js';

const ReservationProfileStatus = ({
  reservationProfile,
  upsellTotal,
  showUpsellStatus = true,
}) => {
  const hasPreArrivalInteraction = !!reservationProfile.preArrivalInteraction;
  const totalAmount = upsellTotal?.total ?? 0;
  const totalCurrency = upsellTotal?.currency ?? reservationProfile.upsellSummary?.currency ?? 'EUR';
  const totalHighlightStyle = {backgroundColor: colors.success10, color: colors.success};

  const fields = [
    {
      label: 'Res. Status',
      content: <ReservationStatusLabel status={reservationProfile.reservationStatus} />,
    },
    {label: 'Res. ID', content: reservationProfile.channelReference},
    {label: 'Language', content: reservationProfile.guest?.language || '-'},
  ];

  if (showUpsellStatus) {
    fields.push({
      label: 'Upsell Status',
      content: (
        <UpsellStatusLabel
          status={reservationProfile.status}
          upsellingBlocker={reservationProfile.upsellingBlocker}
        />
      ),
    });
  } else if (hasPreArrivalInteraction) {
    fields.push({
      label: 'Pre-Arrival Interaction',
      content: (
        <PreArrivalInteractionLabel
          preArrivalInteraction={reservationProfile.preArrivalInteraction}
          abandonedCart={reservationProfile.abandonedCart}
          reservation={reservationProfile}
        />
      ),
    });
  }

  fields.push({
    label: 'Total',
    content: totalAmount > 0 ? formatCurrency(totalAmount, totalCurrency) : '-',
    highlight: totalAmount > 0,
  });

  return (
    <Table cellAlign="center" style={{marginBottom: 20}}>
      <TableHead>
        {fields.map((field) => (
          <TableHeader key={field.label}>{field.label}</TableHeader>
        ))}
      </TableHead>
      <tbody>
        <TableRow>
          {fields.map((field) => (
            <TableCell key={field.label} style={field.highlight ? totalHighlightStyle : undefined}>
              {field.content}
            </TableCell>
          ))}
        </TableRow>
      </tbody>
    </Table>
  );
};

ReservationProfileStatus.propTypes = {
  reservationProfile: PropTypes.shape({
    reservationStatus: PropTypes.string,
    status: PropTypes.string,
    channelReference: PropTypes.string,
    upsellingBlocker: PropTypes.string,
    preArrivalInteraction: PropTypes.string,
    abandonedCart: PropTypes.object,
    upsellSummary: PropTypes.shape({
      currency: PropTypes.string,
    }),
    guest: PropTypes.shape({
      language: PropTypes.string,
    }),
  }).isRequired,
  upsellTotal: PropTypes.shape({
    total: PropTypes.number,
    currency: PropTypes.string,
  }),
};

export default ReservationProfileStatus;
